import { render, staticRenderFns } from "./AttachmentDropZone.vue?vue&type=template&id=3a761350&scoped=true&"
import script from "./AttachmentDropZone.vue?vue&type=script&lang=js&"
export * from "./AttachmentDropZone.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDropZone.vue?vue&type=style&index=0&id=3a761350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a761350",
  null
  
)

export default component.exports